import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const SignupAadhaarOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, panDetails, aadhaarNumber, demoAadhaarOtp } = location.state || {};
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mobile || !aadhaarNumber) {
      navigate('/signup', { replace: true });
    }
  }, [mobile, aadhaarNumber, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (otp.trim().length !== 6) {
      toast.error('Please enter the 6-digit OTP');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call
      // const response = await authServices.verifyAadhaarOtp(aadhaarNumber, otp.trim());

      await new Promise(resolve => setTimeout(resolve, 1000));

      if (otp.trim() !== demoAadhaarOtp) {
        toast.error('Invalid OTP. Please try again.');
        setLoading(false);
        return;
      }

      toast.success('Aadhaar verified successfully');
      navigate('/signup/business-details', {
        state: { mobile, panDetails, aadhaarNumber }
      });
    } catch (error) {
      toast.error('Failed to verify OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Verify Aadhaar OTP"
      subtitle={`Enter OTP sent for Aadhaar ${aadhaarNumber || 'verification'}`}
      onBack={() => navigate('/signup/aadhaar', { state: { mobile, panDetails } })}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">OTP</label>
          <input
            type="tel"
            className="form-input"
            maxLength={6}
            value={otp}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setOtp(value);
            }}
            placeholder="Enter 6-digit OTP"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupAadhaarOtp;


